import React, {FunctionComponent} from 'react';

export const KontaktTextblock: FunctionComponent = () => {
    return (
        <div className='bookmark-overview__textblock'>
            <div className='textblock'>
                <h2>Sie benötigen Unterstützung?</h2>
                <p>Nutzen Sie unser Kontaktformular und lassen Sie sich von den juris Experten beraten.</p>
                <a href={'/jportal/nav/services/kontakt/index.jsp'}
                   className='text-icon-link text-icon-link--link'>
                    <span className='text-icon-link__icon'/>
                    <span className='text-icon-link__text'>Zum Kontaktformular</span>
                </a>
            </div>
        </div>
    );
};